<template>
  <div>
    <div
      :style="{
        position: 'absolute',
        top: mmToEm(doubleRack ? (isUpper ? 25 : -25) : 0)
      }"
    >
      <div
        :style="{
          position: 'absolute',
          top: 0,
          width: mmToEm(selectedUprights.width),
          height: mmToEm(55),
          background:
            gableColor,
          zIndex: 1000
        }"
      />
      <div
        :style="{
          position: 'absolute',
          top: mmToEm(55),
          left: mmToEm(selectedUprights.width / 2 - 10),
          width: mmToEm(20),
          height: mmToEm(1100 - 110 + (doubleRack && isUpper ? 400 : 0)),
          background:
            gableColor,
          zIndex: 1000
        }"
      />
      <div
        :style="{
          position: 'absolute',
          top: mmToEm(1100 - 55),
          width: mmToEm(selectedUprights.width),
          height: mmToEm(55),
          background:
            gableColor,
          zIndex: 1000
        }"
      />

      <template v-if="isRightmost">
        <div
          :style="{
            left: mmToEm(sector.beam.length + selectedUprights.width),
            position: 'absolute',
            top: 0,
            width: mmToEm(selectedUprights.width),
            height: mmToEm(55),
            background:
              gableColor,
            zIndex: 1000
          }"
        />
        <div
          :style="{
            position: 'absolute',
            top: mmToEm(55),
            left: mmToEm(
              sector.beam.length +
                selectedUprights.width +
                (selectedUprights.width / 2 - 10)
            ),
            width: mmToEm(20),
            height: mmToEm(1100 - 110 + (doubleRack && isUpper ? 400 : 0)),
            background:
              gableColor,
            zIndex: 1000
          }"
        />
        <div
          :style="{
            position: 'absolute',
            left: mmToEm(sector.beam.length + selectedUprights.width),
            top: mmToEm(1100 - 55),
            width: mmToEm(selectedUprights.width),
            height: mmToEm(55),
            background:
              gableColor,
            zIndex: 1000
          }"
        />
      </template>
    </div>

    <div
      v-show="includeImpactProtectors && isLeftmost"
      :style="{
        position: 'absolute',
        boxSizing: 'border-box',
        left: mmToEm(-175),
        top: mmToEm(0),
        zIndex: 1000
      }"
    >
      <div
        v-if="!doubleRack || (doubleRack && isUpper)"
        :style="{
          position: 'absolute',
          height: mmToEm(75),
          width: mmToEm(75),
          top: mmToEm(0),
          background:
            impactProtectorColor
        }"
      />
      <div
        v-if="!doubleRack || (doubleRack && !isUpper)"
        :style="{
          position: 'absolute',
          height: mmToEm(75),
          width: mmToEm(75),
          top: mmToEm(1100 - 75),
          background:
            impactProtectorColor
        }"
      />

      <div
        :style="{
          position: 'absolute',
          left: mmToEm(5),
          height: mmToEm(950 + (doubleRack && isUpper ? 450 : 0)),
          width: mmToEm(65),
          top: mmToEm(75),
          background:
            gableColor
        }"
      />

      <div
        :style="{
          position: 'absolute',
          left: mmToEm(70),
          height: mmToEm(75),
          width: mmToEm(85),
          top: mmToEm(150),
          background:
            gableColor
        }"
      />

      <div
        :style="{
          position: 'absolute',
          left: mmToEm(70),
          height: mmToEm(75),
          width: mmToEm(85),
          top: mmToEm(875),
          background:
            gableColor
        }"
      />
    </div>

    <div
      v-show="includeImpactProtectors && isRightmost"
      :style="{
        position: 'absolute',
        boxSizing: 'border-box',
        left: mmToEm(sector.beam.length + selectedUprights.width + 145),
        top: mmToEm(0),
        zIndex: 1000
      }"
    >
      <div
        v-if="!doubleRack || (doubleRack && isUpper)"
        :style="{
          position: 'absolute',
          left: mmToEm(70),
          height: mmToEm(75),
          width: mmToEm(75),
          top: mmToEm(0),
          background:
            impactProtectorColor
        }"
      />
      <div
        v-if="!doubleRack || (doubleRack && !isUpper)"
        :style="{
          position: 'absolute',
          left: mmToEm(70),
          height: mmToEm(75),
          width: mmToEm(75),
          top: mmToEm(1100 - 75),
          background:
            impactProtectorColor
        }"
      />

      <div
        :style="{
          position: 'absolute',
          left: mmToEm(75),
          height: mmToEm(950 + (doubleRack && isUpper ? 450 : 0)),
          width: mmToEm(65),
          top: mmToEm(75),
          background:
            gableColor
        }"
      />

      <div
        :style="{
          position: 'absolute',
          height: mmToEm(75),
          width: mmToEm(85),
          top: mmToEm(150),
          background:
            gableColor
        }"
      />

      <div
        :style="{
          position: 'absolute',
          height: mmToEm(75),
          width: mmToEm(85),
          top: mmToEm(875),
          background:
            gableColor
        }"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    isLeftmost: Boolean,
    isRightmost: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    sector: Object,
    isUpper: Boolean
  },
  data() {
    return {
      gableColor: 'linear-gradient(90deg, rgba(201,201,201,1) 0%, rgba(147,147,147,1) 5%, rgba(131,131,131,1) 46%, rgba(112,112,112,1) 50%, rgba(143,143,143,1) 54%, rgba(131,131,131,1) 95%, rgba(75,75,75,1) 100%)',
      impactProtectorColor: 'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(255,15,0,1) 3%, rgba(230,15,0,1) 15%, rgba(180,15,0,1) 16%, rgba(253,15,0,1) 97%, rgba(179,15,0,1) 100%)'
    }
  },
  computed: {
    ...mapState([
      "selectedUprights",
      "selectedHeight",
      "includeImpactProtectors",
      "doubleRack"
    ])
  },
  methods: {
    mmToEm(mm) {
      return mm / 1000 + "em";
    }
  }
};
</script>
